import { Navigate, Outlet } from "react-router";
import { useAtomValue } from "jotai";
import { authAtom } from "../stores/auth";
import { useHydratePreferences } from "../hooks/useHydratePreferences";

export default function ProtectedRoute() {
  const auth = useAtomValue(authAtom);

  // Pull server-stored display preferences (locale/timezone) once we're inside the
  // authenticated shell, so they follow the user across devices. Server is the
  // source of truth; a NULL field or a failed fetch leaves the client default in
  // place (see the hook). Called unconditionally (hooks rule) with the auth flag.
  useHydratePreferences(auth.isAuthenticated);

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const pendingInvite = localStorage.getItem("pending_invite");
  if (pendingInvite) {
    return <Navigate to={`/invite/${pendingInvite}`} replace />;
  }

  return <Outlet />;
}
